import './listing-information.css';
import React, { useMemo } from 'react';
import { ListingFeatures } from './listing-features';
import { ListingRooms } from './listing-rooms';
import { ListingOverview } from './listing-overview';
import { Mortgage } from './mortgage/mortgage';
import { IListing } from '../../../models/listing.model';
import { Neighbourhood } from './neighbourhood';
import { Footer } from './footer';
import { IBranding } from '../../../models/branding.model';

export interface IListingInformation {
  listing: IListing;
  branding: IBranding;
}

export const ListingInformation: React.FC<IListingInformation> = (props: IListingInformation) => {
  const hasRooms = useMemo(() => (props.listing.rooms.length > 0), [props.listing.rooms]);
  const hasMortgage = useMemo(() => (props.listing.saleOrLease === 'sale'), [props.listing.saleOrLease]);

  return (
    <div className="listing-information">
      <nav className="listing-information-menu-navbar" aria-label="page">
        <ul className="listing-information-menu-nav">
          <li>
            <a href="#overview">Overview</a></li>
          <li>
            <a href="#features">Facts and Features</a>
          </li>
          {
            hasRooms &&
            <li>
              <a href="#rooms">Room Details</a>
            </li>
          }
          <li>
            <a href="#neighbourhood">Neighbourhood</a>
          </li>
          {
            hasMortgage &&
            <li>
              <a href="#mortgage">Mortgage</a>
            </li>
          }
        </ul>
      </nav>
      <div className="listing-information-stack">
        <ListingOverview listing={props.listing} />
        <ListingFeatures listing={props.listing} />
        {
          hasRooms &&
          <ListingRooms listing={props.listing} />
        }
        <Neighbourhood branding={props.branding} listing={props.listing} />
        {
          hasMortgage &&
          <Mortgage address={props.listing.address} price={props.listing.price} />
        }
        <Footer listing={props.listing} />
      </div>
    </div>
  );
}

export default ListingInformation;
